import { useCurrentBox } from "@modules/box/useBox"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { roleBoxStaffPermissions } from "@modules/boxStaff/utils/boxStaffUtils"

export const useBoxStaffPermission = (permission: BoxStaffPermissions) => {
  const { result: box } = useCurrentBox()

  if (!box) {
    return false
  }

  const allowedBoxStaffPermissions = box.currentUserRole ? roleBoxStaffPermissions[box.currentUserRole] || [] : []
  return allowedBoxStaffPermissions.includes(permission)
}
